import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { localize } from 'wanderu-i18n';

import spinner from 'wanderu-assets/images/spinner.svg';
import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import styles from './Spinner.scss';

function Spinner(props) {
    const {
        alt,
        className = '',
        t,
    } = props;

    return (
        <div
            aria-label={t('loading')}
            className={classNames(
                className,
                styles.loaderContainer,
            )}
        >
            <img
                alt={alt || t('loading')}
                className={classNames(
                    styles.loader,
                )}
                src={spinner}
            />
        </div>
    );
}

Spinner.propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    t: PropTypes.func.isRequired,
};

export { Spinner };
export default localize(Spinner, baseAppConfig.namespace);
